import buyerStep1 from './images/buyer-step-1.svg';
import buyerStep2 from './images/buyer-step-2.svg';
import buyerStep3 from './images/buyer-step-3.svg';
import buyerStep4 from './images/buyer-step-4.svg';
import buyerStep5 from './images/buyer-step-5.svg';
import sellerStep1 from './images/seller-step-1.svg';
import sellerStep2 from './images/seller-step-2.svg';
import sellerStep3 from './images/seller-step-3.svg';

export const SECTION_KEYS = {
    SELLER: 'seller',
    BUYER: 'buyer',
    IDEAS: 'ideas',
};

const IMAGE_SIZE = {
    width: 555,
    height: 410,
};

export const HOW_DOES_IT_WORK_CONTENT = {
    [SECTION_KEYS.BUYER]: [
        {
            id: 1,
            animationName: 'buyer-step-1',
            image: buyerStep1,
            size: IMAGE_SIZE,
            reverseDirection: true,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 2,
            animationName: 'buyer-step-2',
            image: buyerStep2,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 3,
            animationName: 'buyer-step-3',
            image: buyerStep3,
            size: IMAGE_SIZE,
            reverseDirection: true,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 4,
            animationName: 'buyer-step-4',
            image: buyerStep4,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 5,
            animationName: 'buyer-step-5',
            image: buyerStep5,
            size: IMAGE_SIZE,
            reverseDirection: true,
            showGetStarted: false,
            isSmall: false,
        },
    ],
    [SECTION_KEYS.IDEAS]: [
        {
            id: 1,
            animationName: 'buyer-step-1',
            image: buyerStep1,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 2,
            animationName: 'buyer-step-2',
            image: buyerStep2,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 3,
            animationName: 'buyer-step-3',
            image: buyerStep3,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: false,
            isSmall: false,
        },
    ],
    [SECTION_KEYS.SELLER]: [
        {
            id: 1,
            animationName: 'seller-step-1',
            image: sellerStep1,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 2,
            animationName: 'seller-step-2',
            image: sellerStep2,
            size: IMAGE_SIZE,
            reverseDirection: true,
            showGetStarted: false,
            isSmall: false,
        },
        {
            id: 3,
            animationName: 'seller-step-3',
            image: sellerStep3,
            size: IMAGE_SIZE,
            reverseDirection: false,
            showGetStarted: true,
            isSmall: true,
        },
    ],
};
